<qpoint-map #qpointMap [fitToBoundsDelay]="100" [debugOutput]="true" [showFitBoundsButton]="true"
    [stopFitToBoundsOnManualInteraction]="false" (mapRightClick)="mapRightClick($event.latLng.lat(), $event.latLng.lng())"
    [contextMenu]="mapContextMenu" (contextmenu)="rightClick($event)" [showSelector]="showSelector()"
    [showZoomButtons]="showZoomButton" [enableFullscreenControl]="enableFullscreenButton()"
    (mapLoaded)="mapLoaded($event)" [setZoomLevelOnFitBounds]="true" [zoom]="13" [modes]="mapModes" [zoomPosition]="zoomPosition"
    [fitToBoundsOnMarkerChanges]="true" [initialLoading]="initialLoading" [selectorTemplate]="selectorTemplate"
    (fitBoundsChanged)="onBoundsChanged($event)" [mapTypePosition]="mapTypePosition"
    [localStorageKey]="localStorageKey"
    [showFocusButton]="showFocusButton" [focusElements] = "focusElements"
    (focusChanged)="focusChanged($event)" [activeFocus]="focusElements[0]" 
    [closeAllWindowsOnMarkerChange]="true" [closeOtherWindowsOnMarkerKlick]="true">
    <qpoint-map-direction [direction]="directionData"></qpoint-map-direction>
    <qpoint-map-marker *ngFor="let poi of additionalMarkerOptions$()"
      [options]="{zIndex: getZIndexByPoiType(poi.type), position: {lat: poi.position.lat, lng: poi.position.lng}, icon: poi.icon, draggable: !poi.readonly && isInEditMode}"
      (mapMarkerRightClick)="markerRightClicked($event)"
      [fitToBounds]="poi.fitToBounds" (infoWindowClosed)="shuffleMarkers()">
      <ng-template qpointMapMarkerLabel *ngIf="poi.label" [shiftLabelHorizontal]="30"
        [shiftLabelVertical]="-25">
        <div>
          <div class="poi-label-container">
            <div class="bold">{{poi.label}}</div>
            <div class="thin pad-left" *ngIf="poi.labelAddendum">{{poi.labelAddendum}}</div>
          </div>
          <div *ngIf="poi.labelSecondRow" class="thin">{{poi.labelSecondRow}}</div>
        </div>
      </ng-template>
      <div>
        <span>Marker Click Template</span>
        <qpoint-button (buttonClicked)="printToConsole()">Print to console</qpoint-button>
      </div>
    </qpoint-map-marker>
</qpoint-map>

<ng-container>
    <ng-container *ngTemplateOutlet="poiSelection"></ng-container>
</ng-container>

<ng-template #poiSelection>
    <kendo-popup #popup [offset]="popupOffset" *ngIf="popupOffset && editMarker && showOverlay"
      [popupAlign]="popupAlign" [anchorAlign]="anchorAlign" (mousewheel)="$event.stopPropagation()">
      <div [ngClass]="currentActionGeoPoint ? 'poi-menu' : 'poi-menu-width-fix'"
        style="max-height: 400px; overflow-y: auto">

        <ng-container *ngIf="!currentActionGeoPoint">
          <qpoint-button *ngFor="let geoPointOption of geoPointOptions"
            (buttonClicked)="geoPointOptionTriggered(geoPointOption)" block="true" class="w-100"
            btnClass="rounded-0 border-0 w-100 map-context-menu-btn justify-content-start" qPointButtonType="primary">
            <div class="d-flex flex-row justify-content-between">
              <div>
                <img [src]="geoPointOption.icon.url">{{ geoPointOption.label }}
              </div>
            </div>
          </qpoint-button>
        </ng-container>

        <qpoint-button *ngIf="currentActionGeoPoint"
          btnClass="rounded-0 border-0 w-100 map-context-menu-btn justify-content-start" block="true"
          class="w-100 d-flex" qPointButtonType="primary" (buttonClicked)="deleteCurrentPoi()" style="height: 40px;">
          Delete
        </qpoint-button>

      </div>
    </kendo-popup>
</ng-template>

<ng-template #selectorTemplate>
  <qpoint-map-plant-suggestlist
    [plantsWithRoutes]="itemsSignal()"
    [selectedPlantId]="itemsSignal()[0].id"
    (plantChanged)="handleEvent($event)">
  </qpoint-map-plant-suggestlist>
</ng-template>

<qpoint-button (buttonClicked)="toggleSelector()" [class.active]="showSelector()">Show suggestlist</qpoint-button>
<qpoint-button (buttonClicked)="toggleEnableFullScreenButton()" [class.active]="enableFullscreenButton()">Enable Fullscreen</qpoint-button>
<qpoint-button (buttonClicked)="openFirstInfoWindow()">Open info window of first marker</qpoint-button>
<qpoint-button (buttonClicked)="closeFirstInfoWindow()">Close info window of first marker</qpoint-button>
